module.exports = __webpack_public_path__ + "assets/1792649897182/img/top-logo.c24719ba.png";